export enum WithdrawStatus {
  NotSupported = "NotSupported",
  NotConnected = "NotConnected",
  Unsettle = "Unsettle",
  InsufficientBalance = "InsufficientBalance",
  Normal = "Normal",
}
